import { createFileRoute } from '@tanstack/react-router'

import { AddUserGroupModal } from '@/user-groups/components/AddUserGroupModal/AddUserGroupModal'

export const Route = createFileRoute('/company/_management/groups/add')({
  component: IndexComponent,
})

function IndexComponent() {
  const navigate = Route.useNavigate()
  return (
    <AddUserGroupModal
      onClose={() => {
        navigate({ to: '/company/groups' })
      }}
    />
  )
}
